import { Routes } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },

  {
    path: 'home',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/home/home.component').then(m => m.HomeComponent),
  },

  {
    path: 'schedule',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/schedule-select/schedule-select.component').then(m => m.ScheduleSelectComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/schedule-professionals/schedule-professionals.component').then(m => m.ScheduleProfessionalsComponent),
      },
      {
        path: 'user-creation',
        loadComponent: () =>
          import('./features/user-creation/user-creation.component').then(m => m.UserCreationComponent),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('./features/schedule-calendar/schedule-calendar.component').then(m => m.ScheduleCalendarComponent),
      },
      {
        path: 'config',
        loadComponent: () =>
          import('./features/schedule-creation/schedule-creation.component').then(m => m.ScheduleCreationComponent),
      },
      {
        path: 'confirm',
        loadComponent: () =>
          import('./features/schedule-confirm/schedule-confirm.component').then(m => m.ScheduleConfirmComponent),
      },
      {
        path: 'block-turns',
        loadComponent: () =>
          import('./features/schedule-block-turns/schedule-block-turns.component').then(m => m.ScheduleBlockTurnsComponent),
      }
    ]
  },

  {
    path: 'user-creation',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/user-creation/user-creation.component').then(m => m.UserCreationComponent),
  },
  {
    path: 'schedule-calendar',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/schedule-calendar/schedule-calendar.component').then(m => m.ScheduleCalendarComponent),
  },
  {
    path: 'schedule-confirm',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/schedule-confirm/schedule-confirm.component').then(m => m.ScheduleConfirmComponent),
  },
  {
    path: 'schedule-creation',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/schedule-creation/schedule-creation.component').then(m => m.ScheduleCreationComponent),
  },

  {
    path: '**',
    redirectTo: 'home',
  }
];